import { render, staticRenderFns } from "./SaatavariviTable.vue?vue&type=template&id=dd5942ae&scoped=true&"
import script from "./SaatavariviTable.vue?vue&type=script&lang=js&"
export * from "./SaatavariviTable.vue?vue&type=script&lang=js&"
import style0 from "./SaatavariviTable.vue?vue&type=style&index=0&id=dd5942ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5942ae",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VForm,VIcon,VMenu,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd5942ae')) {
      api.createRecord('dd5942ae', component.options)
    } else {
      api.reload('dd5942ae', component.options)
    }
    module.hot.accept("./SaatavariviTable.vue?vue&type=template&id=dd5942ae&scoped=true&", function () {
      api.rerender('dd5942ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SaatavariviTable.vue"
export default component.exports